// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__NMIUT","sectionTitle":"styles_sectionTitle__yz6CG","contentWrapper":"styles_contentWrapper__yzkmT","accordion":"styles_accordion___xtf3"};